/*
 * Public API Surface of primeng
 */

export * from './lib/ui-primeng';
